import type { FaireProductEntity } from "../../entity_types/product";

export const p_fybw5kxfac: FaireProductEntity = {
  token: "p_fybw5kxfac",
  type: "product",
  name: "New England Foods Collection (Simplified) - Art Print",
  brandToken: "b_2nlyab4cca",
  brandName: "Sarah Wormann Art",
  imageUrl: "https://cdn.faire.com/fastly/7d06e1a1df51ad13f1faab34ae1dad29623a747f3e5ff3158b7d2ebc5350bb10.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3a5c8d89c21eb8b205e239f0b830fbf5b037a3827eab49bf3eec8ddc23b947fc.jpeg",
    "https://cdn.faire.com/fastly/9d391f81e09c8ff5d30a4ad7173aeb93065fdfdc9336cc8b8f56f9f262b22a04.jpeg",
    "https://cdn.faire.com/fastly/fd8040d7f1d4f13bcccb96607463c659a9988daabc3a010213be181d0f3d1569.jpeg",
    "https://cdn.faire.com/fastly/11f546278aec37e6304dd83fb6d4740144056b868150e238f8063c7917ddaf03.jpeg"
  ],
  priceDollars: 10,
  description: "Fine art print of a collection of New England foods (simplified without any commercial branding), originally created with watercolor and ink.\n\nAll art prints are painted, printed, and packaged by Sarah in her home studio in Boston, MA.\n\n\n𝐏𝐫𝐢𝐧𝐭 𝐝𝐞𝐭𝐚𝐢𝐥𝐬:\n• Printed on archival paper using pigment inks for crisp details and vibrant colors that will last years and years\n• Hand-signed in pencil\n\n𝐒𝐢𝐳𝐞𝐬:\n• Available sizes: 5”x7”, 8”x10”, 11”x14”\n• Print sizes fit standard frames\n\n𝐏𝐚𝐜𝐤𝐚𝐠𝐢𝐧𝐠 𝐚𝐧𝐝 𝐬𝐡𝐢𝐩𝐩𝐢𝐧𝐠:\n• Each print is packaged in a clear sleeve with cardboard backing, ready to display\n• Orders are shipped in a rigid mailer or cardboard box\n• All prints are unframed",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:54.331Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
